@let leftBarOpen = navigationsService.isLeftbarOpen();
<evc-navigation-secondary
  id="fake-bar"
  class="left-bar"
  (isOpenChange)="leftBarIsOpenChange($event)"
  [collapsed]="!leftBarOpen"
  [menus]="leftBarMenu"
  [attr.data-use-leftbar]="true"
  [host]="'leftbar'"
  [class.collapsed]="!leftBarOpen"
>
  <evc-nav-button
    content-before
    type="cta"
    variant="round"
    size="xxl"
    (click)="createReport()"
    [disabled]="!inspection || inspectionImagesCount < 1 || isReadOnly || isDeletedInspection"
  >
    @if (leftBarOpen) {
      <span class="top-cta-label">
        {{ "inspection.report" | translate }}
      </span>
    }
    <evc-svg-icon size="md" [icon]="plusIcon"></evc-svg-icon>
  </evc-nav-button>

  <div class="opened-side-nav-contents" content-after>
    @if (leftBarOpen) {
      <div>
        <ul class="sidenav-tab" fxLayout="row">
          <li
            (click)="changeSidenav(sidenavTypes[0])"
            [class.disabled]="isDeletedInspection"
            [class.selected]="this.sideNavType === sidenavTypes[0]"
            class="tab-style"
          >
            {{ "inspection.folder" | translate }}
          </li>
          <li (click)="changeSidenav(sidenavTypes[1])" [class.selected]="this.sideNavType === sidenavTypes[1]" class="tab-style">
            {{ "inspection.report" | translate }}
          </li>
        </ul>

        <ng-container [ngSwitch]="this.sideNavType">
          <ng-container *ngSwitchCase="sidenavTypes[0]">
            <app-location-folder-tab
              (imageUpload)="upload()"
              *ngIf="subjectModel"
              (updateInspection)="updateInspectionEmit($event)"
              [inspection]="inspection"
              [isReadOnly]="isReadOnly"
              [subjectModel]="subjectModel"
            >
            </app-location-folder-tab>
          </ng-container>

          <ng-container *ngSwitchCase="sidenavTypes[1]">
            <app-inspection-report-tab
              [generatedReports]="generatedReportTree"
              [historyReports]="historyReports"
              [inspectionReport]="report"
              [isDeletedInspection]="isDeletedInspection"
              [isReportLoading]="isReportLoading"
              [selectedFilter]="pastReportFilter"
              [subjects]="subjects4Inspections"
              data-testid="report-tab-content"
            >
            </app-inspection-report-tab>
          </ng-container>
        </ng-container>
      </div>
    } @else {
      <!-- empty element for spacing -->
      <div></div>
    }

    <evc-nav-button type="icon" size="sm" variant="semi" (click)="toggleLeftbar()" class="collaspe-button">
      <evc-svg-icon size="md" [icon]="leftBarOpen ? 'sidebar-collapse' : 'sidebar-expand'" />
    </evc-nav-button>
  </div>
</evc-navigation-secondary>
